import React from "react"
import { StaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import styled from 'styled-components'
/*
 * This component is built using `gatsby-image` to automatically serve optimized
 * images with lazy loading and reduced file sizes. The image is loaded using a
 * `StaticQuery`, which allows us to load the image from directly within this
 * component, rather than having to pass the image data down from pages.
 *
 * For more information, see the docs:
 * - `gatsby-image`: https://gatsby.dev/gatsby-image
 * - `StaticQuery`: https://gatsby.dev/staticquery
 */

 const Wrapper = styled(Img)`
 @media(max-width: 630px){
   width: 100% !important;
 }
 @media(max-width: 937px){
   width: 470px;
 }
 @media(max-width: 768px){
  height: 350px !important;
  width: 470px !important;
 }
 @media(max-width: 528px){
    width: 300px !important;
    height: 230px !important;;
  }
 
 img {
   @media(max-width: 1130px){
     height: auto !important;
     width: 100% !important;
     max-width: 100% !important;
   }
   @media(max-width: 937px){
      width: 470px !important;
   }

   @media(max-width: 528px){
    width: 300px !important;
   }
   
 }
 `
const Image = () => (
  <StaticQuery
    query={graphql`
      query {
        placeholderImage: file(relativePath: { eq: "criando.png" }) {
          childImageSharp {
            fixed(width: 700) {
              ...GatsbyImageSharpFixed,
            }
          }
        }
      }
    `}
    render={data => <div><Wrapper fixed={data.placeholderImage.childImageSharp.fixed} /> </div>}
  />
)
export default Image
